import { render, staticRenderFns } from "./drakesLair.vue?vue&type=template&id=fae57190&"
import script from "./drakesLair.vue?vue&type=script&lang=js&"
export * from "./drakesLair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports